import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';

export default function WebinarSupport() {
  useLanguage();
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-2">{translateInterfaceText("Atendimento")}</h1>
      <p className="text-muted-foreground">{translateInterfaceText("Em desenvolvimento...")}</p>
    </div>
  );
}
